module.exports = "/_next/static/images/document-monotone-5f72343008eacc36d98e213681dadead.svg";